import { Subject, Observable } from 'rxjs';

/**
 * A polyfill for the old ngx-componentdestroyed behavior since a bad global replace
 * wiped out the original componentDestroyed logic.
 *
 * This function intercepts the component's ngOnDestroy method to emit a value
 * through a Subject on destruction.
 */
export function takeUntilDestroyed(component: any): Observable<void> {
  const destroyKey = '__componentDestroyed$';

  if (component[destroyKey]) {
    return component[destroyKey].asObservable();
  }

  const oldNgOnDestroy = component.ngOnDestroy;
  component[destroyKey] = new Subject<void>();

  component.ngOnDestroy = function () {
    if (oldNgOnDestroy) {
      oldNgOnDestroy.apply(component, arguments);
    }
    component[destroyKey].next();
    component[destroyKey].complete();
  };

  return component[destroyKey].asObservable();
}
